var ScrollMagic = ScrollMagic || {};
var Linear = Linear || {};

(function () {
  Drupal.behaviors.holidayPageFormatterV1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var $thismodule = $('.js-holiday-page-v1', context);
      var $window = $(window);
      var $mouseSparkle = $thismodule.find('.js-holiday-cursor');
      var cursorAnimationModules = ['.js-holiday-hero', '.js-holiday-tiles', '.js-holiday-winning-looks', '.js-holiday-container', '.js-holiday-banner-formatter__cta'];
      var $winningLooksBelow = $($thismodule.find('.js-holiday-winning-looks')[1]);
      var $largeTilesBelow = $($thismodule.find('.js-holiday-tiles')[1]);
      var largeTileFound = false;
      var winningLookFound = false;
      // LOGIC
      var particleSettings = {
        FPS: 15,
        particles: {},
        updateInterval: undefined,
        renderInterval: undefined, // Fallback for IE 9
        shouldRender: true
      };

      /**
      * @function spawnParticle
      * @description Spawns particles for a given canvas
      * @param {jQuery} $canvas to spawn particles in
      * @param {number} x X position to spawn particles
      * @param {number} y Y position to spawn particles
      * @param {number} particlesToSpawn Number of particles to spawn
      * @returns {undefined}
      */
      function spawnParticle($canvas, x, y, particlesToSpawn) {
        // LOGIC
        var rotation;
        var anglePosition;
        var baseLifetime = 3000;
        var lifetimeVariance = 1000;
        var lifetime = baseLifetime - (lifetimeVariance * Math.random());
        var startDistance = 10 * Math.random();
        var p = 0;

        if ($canvas.length === 0) {
          return;
        }
        for (p = 0; p < particlesToSpawn; p++) {
          rotation = 360 * Math.random(); // Starting rotation
          anglePosition = 360 * Math.random() * Math.PI / 180;
          particleSettings.particles['p' + Date.now() + p] = {
            canvas: $canvas,
            image: $mouseSparkle[0],
            velocity: {
              x: 2 * Math.cos(rotation * Math.PI / 180),
              y: 2 * Math.sin(rotation * Math.PI / 180)
            },
            position: {
              x: x + startDistance * Math.cos(anglePosition),
              y: y + startDistance * Math.sin(anglePosition)
            },
            rotation: rotation,
            rotationDir: Math.random() >= 0.5 ? 1 : -1,
            endTime: Date.now() + lifetime,
            scale: 1 - 0.8 * Math.random(),
            opacity: 1 - 0.4 * Math.random(),
            lifetime: lifetime
          };
        }
      }

      /**
      * @function particleUpdate
      * @description Logic that updates each particle
      * @returns {undefined}
      */
      function particleUpdate() {
        var particle;
        var currentTime = Date.now();
        var progress;

        Object.keys(particleSettings.particles).forEach(function (key) {
          particle = particleSettings.particles[key];
          progress = (Math.floor(particle.endTime) - currentTime) / particle.lifetime;
          progress = progress <= 0 ? 0 : progress >= 1 ? 1 : progress;

          if (currentTime >= Math.floor(particle.endTime)) {
            delete particleSettings.particles[key];

            return;
          }

          // Lower scale
          particle.scale *= progress;
          particle.scale = particle.scale < 0.01 ? 0 : particle.scale;

          // Update position
          particle.position.x += particle.velocity.x;
          particle.position.y += particle.velocity.y;

          // Update rotation
          particle.rotation += particle.rotationDir;

          // Lower velocity
          particle.velocity.x -= particle.velocity.x * 0.05;
          particle.velocity.y -= particle.velocity.y * 0.05;
        });
      }

      /**
      * @function particleRender
      * @description Renders each particle on canvas
      * @returns {undefined}
      */
      function particleRender() {
        // DOM
        var $canvas;
        var image;
        // LOGIC
        var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
        var particle;
        var context;
        var position;
        var currentTime = Date.now();
        var progress;

        if (!particleSettings.shouldRender) {
          return;
        }

        // Clear each canvas
        $thismodule.find('canvas').each(function () {
          // DOM
          var $this = $(this);
          // LOGIC
          var context = $this.data('context');

          if (typeof context === 'undefined') {
            return;
          }

          context.clearRect(0, 0, context.canvas.width, context.canvas.height);
        });

        // Draw each particle
        Object.keys(particleSettings.particles).forEach(function (key) {
          particle = particleSettings.particles[key];
          $canvas = particle.canvas;
          context = $canvas.data('context');
          image = particle.image;
          position = particle.position;
          progress = (particle.endTime - currentTime) / particle.lifetime;
          progress = progress < 0 ? 0 : progress > 1 ? 1 : progress;
          if (typeof context === 'undefined') {
            return;
          }

          context.globalAlpha = particle.opacity * progress;
          context.translate(position.x, position.y);
          context.scale(particle.scale, particle.scale);
          context.rotate(particle.rotation * Math.PI / 180);
          context.drawImage(image, -image.width / 2, -image.height / 2);
          context.setTransform(1, 0, 0, 1, 0, 0);
          context.globalAlpha = 1;
        });
        if (typeof requestAnimationFrame === 'function') {
          requestAnimationFrame(particleRender);
        }
      }

      /**
      * @function startParticleUpdate
      * @description Starts render and logic loops for particles
      * @returns {undefined}
      */
      function startParticleUpdate() {
        var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

        particleSettings.updateInterval = window.setInterval(particleUpdate, 1000 / particleSettings.FPS);

        particleSettings.shouldRender = true;
        // Use request animation frame if available, otherwise fallback to interval
        if (typeof requestAnimationFrame === 'function') {
          requestAnimationFrame(particleRender);
        } else {
          particleSettings.renderInterval(particleRender(), 1000 / particleSettings.FPS);
        }
      }

      /**
      * @function startParticleUpdate
      * @description Stops render and logic loops for particles
      * @returns {undefined}
      */
      function stopParticleUpdate() {
        if (typeof particleUpdateInterval !== 'undefined') {
          window.clearInterval(particleSettings.updateInterval);
          particleSettings.updateInterval = undefined;
        }

        if (typeof particleRenderInterval !== 'undefined') {
          window.clearInterval(particleSettings.renderInterval);
          particleSettings.renderInterval = undefined;
        }

        particleSettings.shouldRender = false;
      }

      var mouseMoveHandler = (function () {
        var particleSpawnTimeout;

        return function ($canvas, x, y) {
          if (typeof particleSpawnTimeout !== 'undefined') {
            return;
          }

          if ($canvas.length !== 0) {
            spawnParticle($canvas, x, y, 2);
          }
          particleSpawnTimeout = setTimeout(function () {
            particleSpawnTimeout = undefined;
          }, 50);
        };
      })();

      function setModuleCursorAnimationListeners() {
        for (var i = 0; i < cursorAnimationModules.length; i++) {
          $thismodule.find(cursorAnimationModules[i]).unbind('mousemove');
          $thismodule.find(cursorAnimationModules[i]).on('mousemove', function (e) {
            var $canvas = $(this).find('canvas');

            if ($canvas.length !== 0) {
              mouseMoveHandler($canvas, e.pageX - $canvas.offset().left, e.pageY - $canvas.offset().top);
            }
          });
        }
      }

      function initiateCursorAnimation(initial) {
        var $canvas = $thismodule.find('canvas');

        // Initialize each canvas
        $canvas.each(function () {
          // LOGIC
          var context;

          context = this.getContext('2d');
          context.canvas.width = $(this).width();
          context.canvas.height = $(this).height();
          if (initial) {
            $(this).data('context', context);
          }
        });
        if (initial) {
          startParticleUpdate();
        }
        setModuleCursorAnimationListeners();
      }

      $window.on('blur', function () {
        stopParticleUpdate();
      });
      $window.on('focus', function () {
        startParticleUpdate();
      });
      if (!isMobile()) {
        bubbleAnimation();
      }

      function bubbleAnimation() {
        // Init controller for animation of bg bubbles
        var controller = new ScrollMagic.Controller({
          globalSceneOptions: {
            triggerHook: 'onEnter',
            offset: -300,
            duration: '350%'
          }
        });

        // build scenes
        new ScrollMagic.Scene({ triggerElement: '.holiday-page__bubbles--1' })
          .setTween('.holiday-page__bubbles--1 > img', {
            y: '90%',
            ease: Linear.easeNone
          })
          .addTo(controller);
        new ScrollMagic.Scene({ triggerElement: '.holiday-page__bubbles--2' })
          .setTween('.holiday-page__bubbles--2 > img', {
            y: '90%',
            ease: Linear.easeNone
          })
          .addTo(controller);
        new ScrollMagic.Scene({ triggerElement: '.holiday-page__bubbles--3' })
          .setTween('.holiday-page__bubbles--3 > img', {
            y: '90%',
            ease: Linear.easeNone
          })
          .addTo(controller);
        new ScrollMagic.Scene({ triggerElement: '.holiday-page__bubbles--4' })
          .setTween('.holiday-page__bubbles--4 > img', {
            y: '90%',
            ease: Linear.easeNone
          })
          .addTo(controller);
      }

      if (!isMobile()) {
        var $allimages = $thismodule.find('img');

        $allimages.FreeLoader({
          callback: function () {
            initiateCursorAnimation(true);
          }
        });
      }

      function isMobile() {
        return Unison.fetch.now().name === 'small';
      }

      function checkResponsive() {
        if (!isMobile()) {
          initiateCursorAnimation();
        }
      }

      function isInViewport($module) {
        var elementTop = $module.offset().top;
        var elementBottom = elementTop + $module.outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
      }

      function updateCanvasCheck() {
        var isWinningLook = isInViewport($winningLooksBelow);

        if (isWinningLook && !winningLookFound) {
          initiateCursorAnimation();
          winningLookFound = true;
        }
        var isLarger = isInViewport($largeTilesBelow);

        if (isLarger && !largeTileFound) {
          initiateCursorAnimation();
          largeTileFound = true;
        }
      }

      $(window).on('resize', _.debounce(checkResponsive, 100));
      $(window).on('scroll', _.debounce(updateCanvasCheck, 200));
    }
  };
})(jQuery);
